/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { action } from '@ember/object';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { type GenericChangeset } from 'uplisting-frontend/services/repositories/-base';
import { SyncType } from 'uplisting-frontend/components/ui/stay-strategy/v1';

type StayStrategyBooleanChangeset = GenericChangeset<
  | ModelRegistry['bulk-closed-for-arrival']
  | ModelRegistry['bulk-closed-for-departure']
>;

interface IArgs {
  syncType?: SyncType;
  changeset: StayStrategyBooleanChangeset;
  isBulk?: boolean;
}

interface StayStrategyV1BooleanSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiStayStrategyV1BooleanComponent extends Component<StayStrategyV1BooleanSignature> {
  @cached
  get changeset(): StayStrategyBooleanChangeset {
    return this.args.changeset;
  }

  @cached
  get isBulk(): boolean {
    return this.args.isBulk ?? false;
  }

  @action
  handleToggleDay(day: string): void {
    this.changeset[day] = !this.changeset[day];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::StayStrategy::V1::Boolean': typeof UiStayStrategyV1BooleanComponent;
  }
}
